import AppLayout from '@hixme-ui/app-layout'
import { MrModalManager } from '@hixme/modal'
import { Header, SideNav } from 'components'
import { EnvironmentBarProvider } from 'components/Header/environmentIndicator'
import { modals } from 'modal-constants'
import ActivityLogPopup from 'modules/activity-log-service/components/ActivityLogPopup'
import modal from 'modules/app-core/modal'
import notificationManager from 'modules/app-core/notification-manager'
import {
  RequestBoxContainer,
  SystemReportContainer,
} from 'modules/redux-gateway/containers'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import TopBannerAlert from '../../components/TopBannerAlert/TopBannerAlert'
import {
  hideZendeskWidgetIfAllowed,
  showZendeskWidgetIfAllowed,
} from '../../helpers/loadZendeskWidget'
import useFeatureFlags from '../../hooks/useFeatureFlags'
import { useDemoRouteGuard } from 'enrollment-platform/demo-restriction/useDemoRouteGuard'
import { useDemoLoginEvent } from 'enrollment-platform/demo-monitoring/useDemoLoginEvent'
import RegionRestrictedDataBanner from 'enrollment-platform/rbac/RegionRestrictedDataBanner'

const { JodalContainer } = modal.containers
const { NotificationManager } = notificationManager.components

const AdminLayout = ({ companies, children, ...restProps }) => {
  const { flags } = useFeatureFlags()

  // Redirect a demo company's HR admin away from any non-allow-listed admin
  // route (covers every admin page from the shell; re-fires once the selected
  // company hydrates). No-op for other roles and real companies.
  useDemoRouteGuard(restProps.location?.pathname)
  useDemoLoginEvent()

  useEffect(() => {
    if (flags['customer-service.fe.zendesk-widget-enabled']) {
      void showZendeskWidgetIfAllowed()
    }
    return () => {
      hideZendeskWidgetIfAllowed()
    }
  }, [])

  return (
    <div style={{ height: '100%' }}>
      <TopBannerAlert />
      <NotificationManager />
      <JodalContainer {...restProps} />
      <MrModalManager appElementId="app-layout-node" modals={modals} />
      <ActivityLogPopup />
      <div id="app-layout-node" style={{ height: '100%' }}>
        <EnvironmentBarProvider>
          <AppLayout HeaderComponent={Header} SidebarComponent={SideNav}>
            <div>
              <RequestBoxContainer {...restProps} />
              <SystemReportContainer {...restProps} />
              <RegionRestrictedDataBanner />
              <div>{children}</div>
            </div>
          </AppLayout>
        </EnvironmentBarProvider>
      </div>
    </div>
  )
}

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
  companies: PropTypes.array,
}

AdminLayout.defaultProps = {
  companies: [],
}

export default AdminLayout
